import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import '../styles/AboutSection.css';
import { FaHeart, FaComment, FaShare, FaMusic } from 'react-icons/fa';
import OptimizedVideo from '../components/OptimizedVideo';

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  
  return (
    <section id="about" className="section about-section">
      <div className="container">
        <h2 className="section-title">À propos de nous</h2>
        
        <div className="about-content" ref={ref}>
          <motion.div 
            className="about-video-container"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
            transition={{ duration: 0.8 }}
          >
            <div className="about-video">
              <OptimizedVideo 
                src={require('../assets/videos/about-video.MP4')}
                className="vertical-video"
                autoPlay
                loop
                muted
                playsInline
              />
              
              <div className="video-controls">
                <div className="video-info">
                  <span className="video-tag"><FaMusic /> Saldae Voyage Experience</span>
                  <p className="video-description">Découvrez notre agence et nos services exclusifs</p>
                </div>
                <div className="video-icons">
                  <FaHeart className="video-icon" />
                  <FaComment className="video-icon" />
                  <FaShare className="video-icon" />
                </div>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h3>Votre partenaire de confiance pour tous vos voyages</h3>
            <p>
              Saldae Voyage est une agence de voyage complète basée à Béjaïa, offrant une gamme 
              complète de services pour répondre à tous vos besoins de voyage et d'immigration.
            </p>
            <p>
              Avec des années d'expérience dans le domaine, notre équipe d'experts se consacre à 
              vous offrir des solutions personnalisées, qu'il s'agisse de billetterie, de voyages 
              organisés, de démarches pour études à l'étranger ou d'assistance pour l'obtention de visas.
            </p>
            <p>
              Notre mission est de rendre vos projets de voyage et d'études à l'étranger aussi 
              simples et agréables que possible, en vous accompagnant à chaque étape du processus.
            </p>
            
            <div className="about-stats">
              <motion.div 
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <h4>10+</h4>
                <p>Années d'expérience</p>
              </motion.div>
              
              <motion.div 
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <h4>5000+</h4>
                <p>Clients satisfaits</p>
              </motion.div>
              
              <motion.div 
                className="stat"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <h4>20+</h4>
                <p>Destinations</p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 